module.exports = __webpack_public_path__ + "img/wechat.bc7987f0.png";